import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { storeCustomerServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCustomerServices";

const UpdateCustomer = ({
  show,
  hide,
  title,
  storeCustomerData,
  getStoreCustomerList,
  setStoreCustomerData,
  setStoreCustomerIds,
}) => {
  const [name, setName] = useState("");
   const [email, setEmail] = useState("");
   const [phone, setPhone] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedStoreCustomer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this Store Customer?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.customerId = storeCustomerData?.customerId
        userData.name = name
        userData.email = email
        userData.phone = phone
        userData.settings = "update"
        let data = await storeCustomerServices.updatedStoreCustomer(userData)
        if (data?.statusCode === 200) {
          clearData();
          getStoreCustomerList()
          setStoreCustomerIds([])
          setStoreCustomerData("")
        }
        setLoader(false)
      }
    });
  };

  const clearData = () => {
    setName("");
    setEmail("");
    setPhone("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (show && storeCustomerData) {
      setName(storeCustomerData?.name);
      setEmail(storeCustomerData?.email);
      setPhone(storeCustomerData?.phone);
      setLoader(false)
    }
  }, [show, storeCustomerData]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Phone <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter Phone"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button
              onClick={updatedStoreCustomer}
              disabled={!name || !phone || !email || loader}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdateCustomer;
